import { Component, OnInit, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { FermeStateService } from '../../core/services/entities/ferme-state.service';
import { Ferme } from '../../core/models/ferme.model';

const ROUTE_TITLES: Record<string, string> = {
  '/dashboard':   'Tableau de bord',
  '/maraichage':  'Cultures',
  '/betail':      'Cheptel',
  '/pisciculture':'Cohortes de poissons',
  '/finances':   'Finance',
  '/factures':   'Factures',
  '/ged':         'Documents',
  '/farm-map':    'Carte de la ferme',
  '/partenaires': 'Partenaires',
  '/fermes':      'Ma ferme',
  '/users':       'Utilisateurs',
  '/statistiques':'Statistiques',
  '/analyste':    'Analyste',
  '/articles':    'Articles du site',
  '/contacts-crm':'Contacts',
  '/stock':       'Stock',
  '/taches':      'Tournées',
  '/abonnement':  'Mon abonnement',
  '/plateforme/abonnements': 'Plateforme',
  '/volaille':    'Poulailler',
  '/equipements': 'Équipements',
  '/impact':      'Impact',
  '/journal':     'Journal d\'activité',
  '/galerie':     'Galerie',
  '/bassins':     'Bassins',
  '/types-animaux': 'Types d\'animaux',
  '/arbres':      'Arbres fruitiers',
};

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  element: any;
  cookieValue: string;
  flagvalue: any;
  countryName: any;
  valueset: any;
  onlineUser: any;
  pageTitle = 'Tableau de bord';
  ferme: Ferme | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
    private fermeState: FermeStateService,
    private titleService: Title
  ) {}

  listLang = [
    { text: 'Français', flag: 'assets/images/flags/fr.jpg', lang: 'fr' },
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    this.openMobileMenu = false;
    this.element = document.documentElement;

    const currentUser = this.authService.currentUser();
    if (currentUser) {
      this.onlineUser = currentUser;
    }

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/fr.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    // Track ferme state
    this.fermeState.ferme.pipe(takeUntil(this.destroy$)).subscribe(f => this.ferme = f);

    // Track current route for page title
    this.updatePageTitle(this.router.url);
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: NavigationEnd) => {
      this.updatePageTitle(e.urlAfterRedirects);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updatePageTitle(url: string) {
    const base = '/' + (url.split('/')[1] || '');
    this.pageTitle = ROUTE_TITLES[base] || 'Wanar';
    // Titre d'onglet par page (RGAA 8.6) : lu par les lecteurs d'écran, visible dans l'historique
    this.titleService.setTitle(this.pageTitle === 'Wanar' ? 'Wanar' : `${this.pageTitle} · Wanar`);
  }

  /** Prénom affiché : 1er mot du displayName, sinon préfixe de l'e-mail (jamais de nom fictif) */
  get displayName(): string {
    const dn: string = (this.onlineUser?.displayName || '').trim();
    if (dn) { return dn.split(' ')[0]; }
    const email: string = this.onlineUser?.email || '';
    return email ? email.split('@')[0] : '';
  }

  /** Photo de profil : Firebase expose photoURL (logoUrl gardé en repli) */
  get avatarUrl(): string | null {
    return this.onlineUser?.photoURL || this.onlineUser?.logoUrl || null;
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }
}
